import { format } from 'date-fns';
import React from 'react';
import ChartWrapper from 'src/frontend-common/components/Charts/Wrapper';
import { useGetTopCountriesQuery } from 'src/redux/services/adminDashboard';

interface Props {
  dateRange: {
    startDate: Date;
    endDate: Date;
  };
}

const TopCountries: React.FC<Props> = ({ dateRange }) => {
  const {
    data: ipCountriesData,
    isError: isErrorIpData,
    isFetching: isFetchingIpCountries,
    isLoading: isLoadingIpCountries,
  } = useGetTopCountriesQuery({
    start_date: format(dateRange.startDate, "yyyy-MM-dd'T'HH:mm:ss.SSS") + 'UTC',
    end_date: format(dateRange.endDate, "yyyy-MM-dd'T'HH:mm:ss.SSS") + 'UTC',
    field: 'ip_country_code',
  });

  const {
    data: msisdnCountriesData,
    isError: isErrorMsisdnData,
    isFetching: isFetchingMsisdnCountries,
    isLoading: isLoadingMsisdnCountires,
  } = useGetTopCountriesQuery({
    start_date: format(dateRange.startDate, "yyyy-MM-dd'T'HH:mm:ss.SSS") + 'UTC',
    end_date: format(dateRange.endDate, "yyyy-MM-dd'T'HH:mm:ss.SSS") + 'UTC',
    field: 'msisdn_country_code',
  });

  return (
    <ChartWrapper
      key={'latest-companies'}
      isLoading={isLoadingIpCountries || isLoadingMsisdnCountires || isFetchingIpCountries || isFetchingMsisdnCountries}
      isError={isErrorIpData || isErrorMsisdnData}
      components={[
        {
          chart: {
            data: msisdnCountriesData?.items || [],
            type: 'progressChart',
            rowsPerPage: 12,
          },

          isEmpty: !isLoadingMsisdnCountires && !msisdnCountriesData?.items?.length,
          tabLabel: 'Phone',
          title: 'Top Countries',
        },
        {
          chart: {
            data: ipCountriesData?.items || [],
            type: 'progressChart',
            rowsPerPage: 12,
          },

          isEmpty: !isLoadingIpCountries && !ipCountriesData?.items?.length,
          tabLabel: 'IP Address',
          title: 'Top Countries',
        },
      ]}
    />
  );
};

export default React.memo(TopCountries);
